import React from 'react';
import DriverMessage from './Notification/DriverMessage/index';
import PickupReview from './Notification/PickupReview/index';
import { NOTIFICATION_TYPES, NotificationType } from './constants';
import { CardProps, Item, NotificationHandlers, RenderItemParams } from './types';

type CardComponent = React.ComponentType<CardProps<Item>>;

const CARD_REGISTRY: Partial<Record<NotificationType, CardComponent>> = {
  [NOTIFICATION_TYPES.DRIVER_MESSAGE]: DriverMessage,
  [NOTIFICATION_TYPES.TO_BE_REVIEWED_PICKUP]: PickupReview,
};

export const renderItem = ({ item, handlers }: RenderItemParams): React.ReactNode => {
  const Card = CARD_REGISTRY[item.type];

  if (!Card) {
    return null;
  }

  return <Card item={item} handlers={handlers} />;
};
